export default {
	NotifyPayment: 'Nhắc hạn thanh toán',
	OnNotify: 'Bật thông báo',
	OffNotify: 'Tắt thông báo',
	Series: 'Ký hiệu',
	TemplateNo: 'Mẫu số',
	InvoiceNo: 'Số hóa đơn',
	TaxCode: 'Mã số thuế',
	SellerTaxCode: 'Mã số thuế người bán',
	InvoiceDate: 'Ngày hóa đơn',
	SettingDownload: 'Thiết lập tên file tải xuống',
	SettingConnectTax: 'Thiết lập kết nối hệ thống Cơ quan Thuế',
	ContentConnectTax: 'Tải về hóa đơn đầu ra phát hành bởi MISA meInvoice',
	SettingUnDownloadSupplier: 'Thiết lập tải về hóa đơn theo từng nhà cung cấp',
	SupplierFilterOption1: 'Bỏ qua một số nhà cung cấp khi tải hóa đơn',
	SupplierFilterOption2: 'Chỉ tải hóa đơn của các nhà cung cấp được chọn',
	DownloadInvoiceWithoutCode: 'Tải về hóa đơn không mã gửi theo hình thức bảng tổng hợp',
	DownloadOutInvoiceWithoutCode: 'Tải về hóa đơn không mã gửi theo hình thức bảng tổng hợp',
	AutoMoveInvoice: 'Tự động điều chuyển hóa đơn cho chi nhánh/phòng ban',
	Setting: 'Thiết lập',
	Edit: 'Sửa',
	Delete: 'Xóa',
	EmailReceiveInvoice: 'Email nhận hóa đơn',
	OrgName: 'Tên đơn vị',
	SupplierNumber: 'Số lượng nhà cung cấp',
	AddNew: 'Thêm mới',
	SuppliersNoDownloadInvoice: 'Danh sách nhà cung  cấp không tải về hóa đơn',
	Taxaxion: {
		ConfigTransferInvoie: 'Thêm thiết lập điều chuyển hóa đơn',
		ConfigTransfer: 'Thêm thiết lập điều chuyển',
		EditTransferInvoice: 'Sửa thiết lập điều chuyển',
		TakeEmailFromSupplier: 'Nhận hóa đơn từ nhà cung cấp',
		NotFindSupplier: 'Không tìm thấy nhà cung cấp',
		AddConfigSuccess: 'Thêm thiết lập điều chuyển hóa đơn thành công',
		EditConfigSuccess: 'Sửa thiết lập điều chuyển hóa đơn thành công',
		AlertExistConfig: {
			FirstText: 'Đã tồn tại thiết lập tự động điều chuyển hóa đơn cho email',
			SecondText: 'trên danh sách'
		},
		AlertExistConfigSupplier: 'Tồn tại nhà cung cấp đã thiết lập tự động điều chuyển đến ',
		AccountExistConfig: 'Tài khoản đã thiết lập',
		CannotConfig: 'Không thể thiết lập',
		ListAutoTransfer: 'Danh sách tự động điều chuyển hóa đơn cho chi nhánh/phòng ban',
		AlertDeleteBranch: {
			Title: 'Bạn muốn xóa chi nhánh/phòng ban',
			FirstText: 'có email',
			SecondText: 'khỏi danh sách tự động điều chuyển hóa đơn.',
			Detail: 'Dữ liệu sau khi xóa sẽ không thể khôi phục lại.'
		},
		DeleteConfigSuccess: 'Đã xóa thiết lập điều chuyển hóa đơn thành công',
		SupplierInfo: 'Thông tin nhà cung cấp',
		SupplierExistOnSystem: (identity, name) =>
			`Nhà cung cấp <${identity} - ${name}> đã tồn tại trên hệ thống. Vui lòng chọn trong danh sách.`,
		SupplierExist: 'Nhà cung cấp đã tồn tại'
	},
	FillTaxCodeToFind: 'Nhập MST/CCCD chủ hộ hoặc tên NCC để tìm kiếm',
	SupplierName: 'Tên nhà cung cấp',
	Address: 'Địa chỉ',
	NeedDeleteSupplierToAdd:
		'Bạn cần xóa nhà cung cấp trên danh sách điều chuyển hóa đơn của email &lt;info@meinvoice.vn&gt; để thực hiện thêm NCC vào email mới',
	UnitCode: 'Mã đơn vị',
	//Bổ sung 2/12
	UnitName: 'Tên đơn vị',
	SupplierAddress: 'Địa chỉ',
	AddSupplierNoDownload: 'Thêm mới nhà cung cấp không tải về hóa đơn',
	SupplierInfo: 'Thông tin nhà cung cấp',
	NeedSelectOneSupplier: 'Bạn phải chọn ít nhất một nhà cung cấp.',
	NotInfoAboutIndetifyCodes:
		'Không tìm thấy Mã số thuế hoặc CCCD chủ hộ trên trang của Cơ quan Thuế. Vui lòng kiểm tra lại.',
	NotInfoAboutIndetifyCodes1: 'Không tìm thấy Mã số thuế trên trang của Cơ quan Thuế. Vui lòng kiểm tra lại.',
	SupplierExist: 'Nhà cung cấp đã tồn tại trên danh sách.',
	AddSupplierNoDownloadSuccess: 'Thêm thiết lập nhà cung cấp không tải về hóa đơn thành công',
	AddSupplierNoDownloadFail: 'Thêm thiết lập nhà cung cấp không tải về hóa đơn thất bại',
	AddSupplierOnlyDownloadSuccess: 'Thêm thiết lập nhà cung cấp tải về hóa đơn thành công',
	AddSupplierOnlyDownloadFail: 'Thêm thiết lập nhà cung cấp tải về hóa đơn thất bại',
	SupplierWasTransfer: 'Nhà cung cấp đã thiết lập điều chuyển tự động đến phòng ban',
	System: {
		NumberDateNotify: 'Ngày nhắc trước hạn',
		NotifyBefore: 'Nhắc trước hạn',
		FileNameDownLoad: 'Tên file tải xuống gồm:',
		InfoOnFileName: 'Thông tin trên tên file',
		TooltipFileName: maxLength =>
			`Chương trình sẽ tự động cắt ngắn tên file tải xuống nếu độ dài lớn hơn ${maxLength} ký tự`,
		Example: 'Ví dụ:',
		OutInvoice: 'Hóa đơn đầu ra',
		InbotInvoie: 'Hóa đơn đầu vào',
		SelectSupplier: 'Thiết lập',
		SupplierWasSelected: 'Nhà cung cấp được chọn.',
		Change: 'Thay đổi',
		SelectBranchOrDepartment: 'Chọn chi nhánh/phòng ban',
		BuyerTaxCodeSelected: 'MST/CCCD chủ hộ đã được chọn',
		WarningFileNameLength:
			'Nếu tên file của bạn quá dài, hệ thống sẽ tự động bỏ các ký tự cuối để đảm bảo tên file tải xuống được giới hạn trong 100 ký tự.'
	},
	BuyerName: 'Tên người mua',
	BuyerTaxCodeSettingDownload: 'Mã số thuế người mua',
	InvoiceNote: 'Ghi chú',
	SellerName: 'Tên người bán',
	ListSupplierNoDownload: 'Danh sách nhà cung cấp không tải về hóa đơn',
	ConfirmDeleteSupplierNoDownload: 'Dữ liệu sau khi xóa sẽ không thể khôi phục lại.',
	TitleDeleteSupplierNoDown: 'Bạn muốn xóa nhà cung cấp',
	DeleteConfigSupplierNoDownloadSuccess: 'Đã xóa thành công',
	DeleteConfigSupplierNoDownloadFail: 'Xóa thiết lập nhà cung cấp không tải về hóa đơn thất bại',
	DeleteSettingTransferInvSuccess: 'Đã xóa thiết lập điều chuyển hóa đơn tại hộp thư thành công',
	DeleteSettingTransferInvFail: 'Xóa thiết lập điều chuyển hóa đơn tại hộp thư thất bại',
	SettingTransferInvoice: 'Thiết lập điều chuyển hóa đơn từ nguồn email',
	TransferInvByTaxCode: 'Tự động điều chuyển theo Mã số thuế/CCCD chủ hộ của người mua',
	SettingWarningData: 'Thiết lập cảnh báo hóa đơn chưa chính xác về tính toán số liệu',
	SettingCheckingInvoice: 'Thiết lập kiểm tra hóa đơn',
	SettingSupplier: 'Thiết lập nhà cung cấp',
	SettingTemplate: 'Thiết lập mẫu hóa đơn mặc định',
	TitleSettingTemplate: 'Thiết lập mẫu hóa đơn',
	BackgroundImage: 'Hình nền',
	Borders: 'Khung viền',
	FontSize: 'Cỡ chữ',
	Normal: 'Thường',
	Small: 'Nhỏ',
	TooltipFontSize: 'Thiết lập cho mẫu hóa đơn GTGT trên phiên bản Web',
	ProductService: 'Hàng hóa dịch vụ',
	TooltipProductService: 'Thiết lập cho mẫu hóa đơn GTGT trên phiên bản Web',
	No: 'STT',
	Nature: 'Tính chất',
	ItemCode: 'Mã hàng',
	TooltipItemCode:
		'Khi được chọn, cột Mã hàng sẽ tự động hiển thị trên mẫu mặc định nếu xml hóa đơn có thông tin mã hàng',
	SettingBackgroundImageTooltip: 'Thiết lập cho mẫu hóa đơn trên phiên bản Web',
	SettingBorderTooltip: 'Thiết lập cho mẫu hóa đơn trên phiên bản Web, Mobile',
	HideSpecificProductInfo: 'Ẩn thông tin hàng hóa đặc trưng',
	HiddenVatRate: 'Ẩn mức thuế suất không phát sinh',
	HiddenTotalFee: 'Ẩn tổng tiền phí khi không phát sinh',
	HiddenDiscountAmount: 'Ẩn tổng tiền CKTM khi không phát sinh',
	IsStatusInvoiceCancel: 'Hiển thị trạng thái đối với hóa đơn đã bị hủy, bị thay thế, bị điều chỉnh',
	StatusInvoiceTitle: 'Trạng thái hóa đơn',
	WarningOnList: 'Cảnh báo chưa chính xác về tính toán số liệu trên danh sách',
	EmailReceiveAlert: 'Cảnh báo qua email khi có khách hàng/nhà cung cấp thay đổi tình trạng hoạt động',
	ListTransferByTaxCode: 'Danh sách tự động điều chuyển hóa đơn từ nguồn email',
	BuyerTaxCode: 'MST/CCCD chủ hộ của người mua',
	TaxaxionTaxCode: {
		BuyerTaxCodeInv: 'MST/CCCD chủ hộ của người mua trên hóa đơn',
		PlaceHoderBuyerTaxCodeInv: 'Nhập MST/CCCD chủ hộ của người mua để tìm kiếm',
		SettingTransfer: 'Thiết lập điều chuyển',
		AddTransfer: 'Thêm thiết lập điều chuyển',
		EditTransfer: 'Sửa thiết lập điều chuyển',
		ValidOrg: 'chi nhánh/phòng ban chuyển đến.',
		NoExitstOrg: 'Mã số thuế/CCCD chủ hộ không tồn tại trên cơ cấu tổ chức.<br>Vui lòng kiểm tra lại.',
		ValidIndetityCode: 'Vui lòng nhập mã số thuế hoặc căn cước công dân.<br>Vui lòng kiểm tra lại.',
		OrganizationMove: 'Chi nhánh/phòng ban chuyển đến',
		taxCodeText: taxCode => `Mã số thuế &lt;${taxCode}&gt;`,
		identificationNumberText: identificationNumber => `CCCD &lt;${identificationNumber}&gt;`,
		ContainEmailTranfer: (identityCode, email) =>
			`Đã tồn tại thiết lập điều chuyển hóa đơn có ${identityCode} đến email &lt;${email}&gt;. Vui lòng kiểm tra lại.`,
		TaxCode: 'MST',
		IdentificationNumber: 'CCCD chủ hộ'
	},
	ConfirmDeleteTransferInv: 'Dữ liệu sau khi xóa sẽ không thể khôi phục lại.',
	TitleConfirmDeleteTransferInv: 'Bạn muốn xóa thiết lập điều chuyển',
	AddSettingTransferInvSuccess: 'Thêm thiết lập điều chuyển hóa đơn tại hộp thư thành công',
	AddSettingTransferInvFail: 'Thêm thiết lập điều chuyển hóa đơn tại hộp thư thất bại',
	EditSettingTransferInvSuccess: 'Sửa thiết lập điều chuyển hóa đơn tại hộp thư thành công',
	EditSettingTransferInvFail: 'Sửa thiết lập điều chuyển hóa đơn tại hộp thư thất bại',
	ContainSettingTaxCode: 'Đã tồn tại thiết lập mã số thuế trên danh sách',
	AlreadySettingTransferInv: (identityCode, orgName, email) =>
		`${identityCode} đã được thiết lập điều chuyển về chi nhánh/phòng ban &lt;${orgName}&gt; - email &lt;${email}&gt;. Bạn có muốn thay thế thiết lập?`,
	NotAuthorFeature: 'Bạn chưa được phân quyền thực hiện chức năng',
	SelectOtherDownloadInvoice: 'Chọn loại hóa đơn tải về khác',
	SelectDownloadInvoice: 'Chọn loại hóa đơn tải về',
	ShowInvoiceLoadingList: 'Thiết lập hiển thị danh sách hóa đơn đang tải (đang đồng bộ) từ cơ quan thuế',
	ShowInvoiceLoading: 'Hiển thị',
	HideInvoiceLoading: 'Không hiển thị',
	ShowInvoiceLoadingListTooltip:
		'Thiết lập này sẽ hiển thị danh sách “hóa đơn đang tải” (đang đồng bộ) từ cơ quan thuế tại phân hệ hóa đơn đầu vào.',
	ShowOutInvoiceLoadingList: 'Thiết lập hiển thị danh sách hóa đơn đang tải (đang đồng bộ) từ cơ quan thuế',
	ShowOutInvoiceLoadingListTooltip:
		'Thiết lập này sẽ hiển thị danh sách “hóa đơn đang tải” (đang đồng bộ) từ cơ quan thuế tại phân hệ hóa đơn đầu ra.',
	ConfirmUnPaymentInvoice:
		'Chương trình sẽ xóa toàn bộ lịch sử thanh toán của hóa đơn. Dữ liệu sau khi xóa không thể khôi phục lại.',
	ConfirmUnPaymentInvoiceTitle: 'Bạn muốn xóa lịch sử thanh toán',
	UnPaymentInvoiceSuccess: 'Bỏ đánh dấu thanh toán hóa đơn thành công',
	UnPaymentInvoiceFail: 'Bỏ đánh dấu thanh toán hóa đơn thất bại',
	IgnoreCheckExistTax: 'Thiết lập danh sách mẫu số, ký hiệu chấp nhận tồn tại trên CQT',
	TooltipIgnoreCheckExistTax:
		'Khai báo mẫu số, ký hiệu hóa đơn không mã của các nhà cung cấp uy tín nếu không muốn chương trình kiểm tra và cảnh báo hóa đơn không tồn tại trên CQT.',
	ListIgnoreCheckExistTax: 'Danh sách mẫu số, ký hiệu HĐ không mã chấp nhận tồn tại trên CQT',
	StartDate: 'Ngày bắt đầu',
	EndDate: 'Ngày kết thúc',
	SearchPlaceHolder: 'Nhập Tên, MST/CCCD chủ hộ, Ký hiệu để tìm kiếm',
	SupplierAccept: {
		SupplierInfo: 'Thêm mẫu số, ký hiệu của nhà cung cấp',
		WarningValidateDuplicate: (series, taxCode, name) =>
			`Ký hiệu <${series}> của NCC <${taxCode} - ${name}> đã tồn tại.`,
		TitleDuplicate: 'Tồn tại nhà cung cấp',
		InsertSuccess: 'Thêm mới thành công',
		InsertFail: 'Thêm mới thất bại',
		UpdateSuccess: 'Cập nhật thành công',
		UpdateFail: 'Cập nhật thất bại',
		TitleConfirmDelete: 'Bạn muốn xóa mẫu số, ký hiệu',
		ContentConfirmDelete: 'Dữ liệu sau khi xóa sẽ không thể khôi phục lại.',
		DeleteSuccess: 'Đã xóa thành công',
		DeleteFail: 'Xóa thất bại'
	},
	ListEmailAlert: 'Danh sách email nhận cảnh báo',
	EmailAlert: 'Email nhận cảnh báo',
	EmailReceiveAlertInfo: {
		AddEmail: 'Thêm mới email',
		UpdateSuccess: 'Cập nhật thành công',
		InsertSuccess: 'Thêm mới thành công',
		InsertFail: 'Thêm mới thất bại',
		UpdateFail: 'Cập nhật thất bại',
		ConfirmDelete: email => `Bạn có chắc chắn muốn xóa email &lt;${email}&gt; này không?`,
		WarningValidateDuplicate: (series, taxCode, name) => `Email &lt;${series}&gt; đã tồn tại.`,
		DeleteSuccess: 'Đã xóa thành công',
		DeleteFail: 'Xóa thất bại',
		TitleDuplicate: 'Trùng email đã khai báo',
		DeleteConfirmTitle: 'Bạn muốn xóa email nhận cảnh báo',
		DeleteConfirmBody: 'Dữ liệu sau khi xóa sẽ không thể khôi phục lại.'
	},
	NeedDisplayInvoiceNo: 'Bạn cần thiết lập hiển thị Số hóa đơn',
	SaveSettingSuccess: 'Đã thiết lập thành công.',
	SaveSettingFail: 'Thiết lập thất bại',
	SettingRemind: 'Thiết lập nhắc nhở',
	SetupTheCriteriaToBeTested: 'Thiết lập các tiêu chí cần kiểm tra',
	SettingCriteria: 'Thiết lập tiêu chí kiểm tra trên hóa đơn',
	TooltipSettingCriteria: 'Thiết lập các tiêu chí mà người dùng mong muốn chương trình kiểm tra trên hóa đơn.',
	ShowNotificationNew: 'Luôn hiển thị khi có thông báo mới ',
	TemplateDetail: {
		Date: 'Ngày 03 tháng 06 năm 2025',
		TaxAuthorityCode: 'Mã CQT cấp: M1-25-OVEN3-00400038881'
	},
	CostType: 'Loại chi phí',
	Date: 'Thời gian',
	NormsAccordingToInvoice: 'Định mức theo hóa đơn (VND)',
	NormsAccordingToTime: 'Định mức theo thời gian (VND)',
	SettingClassificationInvoice: 'Thiết lập phân loại hóa đơn và định mức chi phí',
	AutoClassification: 'Tự động phân loại',
	CostNorms: 'Định mức chi phí',
	Setting: 'Thiết lập',
	CostNormsDesc: 'Thiết lập định mức theo hóa đơn (VND).',
	AutoClassificationNoted: '"Hóa đơn vào phần mềm sẽ được tự động phân loại theo danh sách chi phí có sẵn"',
	CostTypeList: 'Danh sách loại chi phí',
	CostNormListTitle: 'Thiết lập định mức chi phí theo hóa đơn',
	SeeFeatureIntroduction: 'Xem giới thiệu tính năng',
	NoteCostType:
		'Hiện tại phần mềm tự động nhận diện được các loại chi phí trên. Danh sách loại chi phí đang được tiếp tục cập nhật.',
	SettingStatusInvoiceCancel: 'Đã bị hủy',
	CostNormsByInvoice: 'Định mức chi phí theo hóa đơn',
	CostNormsByInvoiceTooltip:
		'Thiết lập định mức theo từng hóa đơn (VND). Kết quả kiểm tra định mức xem tại danh sách hóa đơn và báo cáo.',
	CostNormsByTime: 'Định mức chi phí theo thời gian',
	CostNormsByTimeTooltip:
		'Thiết lập định mức chi phí theo kỳ tháng/quý/năm (VND). Kết quả kiểm tra định mức xem tại báo cáo.',
	CostNormListTitleByTime: 'Thiết lập định mức chi phí theo thời gian',
	CriteriaSetupForm: {
		Title: 'Thiết lập tiêu chí kiểm tra trên hóa đơn',
		ListCriteria: 'Danh sách tiêu chí',
		CheckedCriteria: 'Kiểm tra tiêu chí',
		ConclusionOfInvalidInvoice: 'Kết luận hóa đơn không hợp lệ',
		TooltipConclusionOfInvalidInvoice:
			'Lựa chọn tiêu chí sẽ ảnh hưởng đến việc kết luận là hóa đơn "có" hay "không" hợp lệ',
		ShowOnList: 'Hiển thị trên danh sách',
		TooltipCheckedCriteria: 'Tiêu chí nào không được lựa chọn sẽ không được kiểm tra trên hóa đơn',
		TooltipDisplayInList: 'Hiển thị kết quả kiểm tra trên Danh sách hóa đơn',
		ConfirmSave:
			'Thay đổi chỉ có tác dụng với các hóa đơn được kiểm tra sau khi thiết lập. Với các hóa đơn cũ, vui lòng nhấn Kiểm tra lại nếu muốn cập nhật kết quả kiểm tra theo thiết lập này.',
		SaveError: 'Lưu thiết lập tiêu chí kiểm tra thất bại'
	},
	TaxCodeAndIdentification: 'MST/CCCD chủ hộ',
	IdentificationNumber: 'CCCD chủ hộ',
	RequiredTaxCodeOrIdentification: 'Bắt buộc nhập 1 trong 2 thông tin "Số định danh cá nhân" hoặc "Mã số thuế"',
	AmountBeforeDiscountSettings: 'Thiết lập công thức tính toán số liệu Thành tiền chưa trừ chiết khấu',
	AmountBeforeDiscountSettingsTooltip:
		'Thiết lập công thức tính toán số liệu Thành tiền chưa trừ chiết khấu cho hóa đơn đầu vào/đầu ra.',
	AmountBeforeDiscountSetup: {
		Title: 'Thiết lập công thức tính Thành tiền chưa trừ chiết khấu',
		Subtitle: 'Công thức tính thành tiền chưa trừ chiết khấu như sau:',
		Formula1Condition: num =>
			`Trường hợp |(SLuong * ĐGia) - ThTien| ≤ <span style="color: #00A2CF;">±${num}</span> đơn vị`,
		Formula1Condition2: '(Giá trị chênh lệch)',
		Formula1Condition1: '→ Thành tiền chưa trừ chiết khấu = ThTien',
		Formula1Result: 'ThTiền',
		Formula2Condition: 'Trường hợp còn lại',
		Formula2Result: '→ Thành tiền chưa trừ chiết khấu = ThTien + STCKhau',
		DeviationLabel: 'Điều chỉnh giá trị chênh lệch',
		DeviationRangeWarning: 'Giá trị chênh lệch được điều chỉnh trong khoảng từ 1 đến 10',
		ColSoLuong: 'Số lượng',
		ColDonGia: 'Đơn giá',
		ColThanhTien: 'Thành tiền chưa trừ chiết khấu',
		ColChietKhau: 'Chiết khấu',
		ColThueSuat: 'Thuế suất',
		Example: 'Ví dụ minh họa',
		FooterNote: 'Thông tin số liệu được lấy trên file XML của hóa đơn'
	},
	AbbreviationSettings: 'Thiết lập kiểm tra tên, địa chỉ người mua/người bán',
	AbbreviationSetup: {
		Title: 'Thiết lập kiểm tra tên, địa chỉ người mua/người bán',
		Warning: 'Chương trình không phân biệt chữ viết hoa, viết thường khi kiểm tra.',
		Warning1:
			'Kết quả kiểm tra đang chấp nhận đúng các từ viết tắt, nếu tích “<span style="font-weight: 700;color: #212529">Cảnh báo</span>” chương trình sẽ <span style="font-weight: 700;color: #F5222D">cảnh báo sai</span> khi tên/địa chỉ người bán trên hóa đơn <span style="font-weight: 700;color: #212529">khác</span> trên <span style="font-weight: 700;color: #212529">thuế</span>, tên/địa chỉ người mua <span style="font-weight: 700;color: #212529">khác</span> trong <span style="font-weight: 700;color: #212529">cơ cấu tổ chức.</span>',
		WordList: 'Danh sách từ',
		Abbreviation: 'Từ viết tắt',
		Check: 'Cảnh báo',
		NameOnTax: 'Tên đơn vị trên thuế',
		AddressOnTax: 'Địa chỉ đơn vị trên thuế',
		NameOnInvoice: 'Tên trên hóa đơn',
		AddressOnInvoice: 'Địa chỉ trên hóa đơn',
		True: 'Đúng',
		False: 'Sai',
		CheckExplanation: 'Giải thích cách kiểm tra',
		FooterNote: 'Thiết lập trên không nằm trong quy định tại NĐ70',
		Cancel: 'Hủy bỏ',
		Save: 'Lưu',
		CheckProvince: 'Kiểm tra chữ "Tỉnh" trong địa chỉ',
		TooltipCheckProvince:
			'Khi tích chọn, chương trình sẽ cảnh báo nếu địa chỉ trên hóa đơn và trên hệ thống khác nhau về chữ "Tỉnh" (Ví dụ: "Tỉnh Hà Nam" và "Hà Nam").'
	},
	SupplierOnlyDownload: {
		TitleFormAddSupplier: 'Thêm mới nhà cung cấp tải về hóa đơn',
		AddSupplierOnlyDownload: 'Thêm mới nhà cung cấp tải về hóa đơn',
		TitleSupplierOnlyDownload: 'Danh sách nhà cung cấp tải về hóa đơn',
		ConfirmDeleteLastSupplierOnlyDownload:
			'<div>Tính năng <strong>Tải hóa đơn theo từng nhà cung cấp</strong> yêu cầu phải có ít nhất một nhà cung cấp trong danh sách. Nếu bạn xóa nhà cung cấp cuối cùng, chương trình sẽ chuyển về chế độ mặc định tải về toàn bộ hóa đơn từ Cơ quan thuế.<br/>Bạn có chắc chắn muốn xóa không?</div>',
		ConfirmDeleteSupplierOnlyDownload: 'Bạn có chắc chắn muốn xóa nhà cung cấp khỏi danh sách không?',
		TitleConfirmBeforeSaveSetting: 'Bạn chưa chọn nhà cung cấp nào để tải hóa đơn',
		Default: 'Chuyển về mặc định',
		Continue: 'Tiếp tục khai báo',
		ConfirmBeforeSaveSetting:
			'Vui lòng khai báo ít nhất một nhà cung cấp hoặc chương trình sẽ chuyển về chế độ mặc định tải về toàn bộ hóa đơn từ Cơ quan thuế. Bạn có muốn tiếp tục khai báo nhà cung cấp không?'
	},
	NoDataSearchSupplierAccept: 'Không tìm thấy thông tin nhà cung cấp theo điều kiện tìm kiếm, vui lòng thử lại',
	EmptyDataSearchSupplierAccept: 'Không có nhà cung cấp nào'
};
